import { useContext, useState } from 'react'
import { Accordion, Button, Card, Modal, useAccordionButton } from 'react-bootstrap'
import { ContextSubject } from './EnableSubject'
import { dayName } from 'utils'
import { BsClock } from 'react-icons/bs'

export function ModalSubject({ show, onHide, changeStateSchedule }) {
    const [listOfSchedulesSelected, setlistOfSchedulesSelected] = useState({})
    const { subjectSelected, setSubjectSelected } = useContext(ContextSubject)

    const handleSubmit = () => {
        changeStateSchedule(listOfSchedulesSelected)
    }
    const reset = () => {
        setlistOfSchedulesSelected({})
        subjectSelected.length > 0 && setSubjectSelected([])
    }
    const handleOnChange = (e, schedule, index) => {
        const value = e.target.checked
        if (!listOfSchedulesSelected[schedule.id]) {
            setlistOfSchedulesSelected((prevState) => ({
                ...prevState,
                [schedule.id]: value,
            }))
        } else {
            setlistOfSchedulesSelected((prevState) => ({
                ...prevState,
                [schedule.id]: value,
            }))
        }
    }
    const toggleChangeState = (e, index, object) => {
        const subjectClone = structuredClone(subjectSelected)
        const schedules = subjectClone[index].horarios

        schedules.forEach((sch) => {
            if (object?.materia_id && sch.id === object.id) {
                sch.habilitado = e.target.checked
                handleOnChange(e, sch)
            } else {
                if (object.codigo) {
                    sch.habilitado = e.target.checked
                    handleOnChange(e, sch)
                }
            }
        })

        setSubjectSelected(subjectClone)
    }
    const CustomToggle = ({ eventKey }) => {
        const decoratedOnClick = useAccordionButton(eventKey, () => {})

        return (
            <button type='button' className='show-schedules' onClick={decoratedOnClick}>
                Ver horarios
            </button>
        )
    }

    return (
        <Modal show={show} size='md' aria-labelledby='contained-modal-title-vcenter' centered onExited={reset}>
            <Modal.Header>
                <div className='w-100 h4 text-center mb-0'>{subjectSelected[0]?.nombre}</div>
            </Modal.Header>
            <Modal.Body>
                <Accordion defaultActiveKey='0'>
                    {subjectSelected?.map((subject, index) => (
                        <Card key={subject.id}>
                            <Card.Header className='card-header'>
                                Grupo {subject.grupo}
                                <div className='card-header-right'>
                                    <CustomToggle eventKey={index} />
                                    <input type='checkbox' onChange={(e) => toggleChangeState(e, index, subject)} />
                                </div>
                            </Card.Header>
                            <Accordion.Collapse eventKey={index}>
                                <Card.Body>
                                    {subject.horarios?.length > 0
                                        ? subject.horarios.map((horario) => (
                                            <div key={horario.id} className='d-flex align-items-center mb-2'>
                                                <BsClock className='me-2' />
                                                <div>
                                                    {dayName(horario.dia)} ⋅ {horario.hora_inicio.slice(0, 5)} - {horario.hora_fin.slice(0, 5)}
                                                </div>
                                                <input
                                                    type='checkbox'
                                                    className='form-check-input ms-auto'
                                                    name='checkboxschedule'
                                                    checked={horario.habilitado}
                                                    onChange={(e) =>
                                                        toggleChangeState(e, index, {
                                                            ...horario,
                                                            grupo: subject.grupo,
                                                        })
                                                    }
                                                />
                                            </div>
                                        ))
                                        : 'No existen horarios'}
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    ))}
                </Accordion>
            </Modal.Body>
            <Modal.Footer className='d-flex justify-content-center'>
                <Button variant='danger' className='me-3' onClick={onHide}>
                    Cancelar
                </Button>
                <Button variant='blue' onClick={handleSubmit}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
